// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_t0-5";
export var filledCircle = "_t0-4";
export var historyEntry = "_t0-3";
export var messageSideLeft = "_t0-1";
export var messageSideRight = "_t0-2";
export var orderTrackingCarouselWrapper = "_t0-6";
export var orderTrackingInfoContainer = "_t0-0";